// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SketchOutlinedSvg from "@fishx/icons-svg/es/asn/SketchOutlined";
import FishxIcon from '../components/FishxIcon';

var SketchOutlined = function SketchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: SketchOutlinedSvg
  }));
};

SketchOutlined.displayName = 'SketchOutlined';
export default React.forwardRef(SketchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/SketchOutlined.js
// module id = 4128
// module chunks = 0